import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { AiFillEye, AiFillGithub } from 'react-icons/ai'
import { v4 as rid } from 'uuid'

import { client, urlFor } from '../../client'
import { WORK_FILTERS } from '../../constants/enum'
import { AppWrap, MotionWrap } from '../../wrapper'
import './Works.scss'

const Works = () => {
  const [works, setWorks] = useState([])
  const [filterWork, setFilterWork] = useState([])
  const [activeFilter, setActiveFilter] = useState('All')
  const [animateCard, setAnimateCard] = useState([
    { y: 0, opacity: 1, duration: 0.1 },
  ])

  useEffect(() => {
    const query = '*[_type == "works"] | order(_updatedAt desc)'

    client.fetch(query).then(data => {
      setWorks(data.filter(work => !work.hidden))
      setFilterWork(data.filter(work => !work.hidden))
    })
  }, [])

  const handleWorkFilter = item => {
    setActiveFilter(item)
    setAnimateCard([{ y: 100, opacity: 0 }])

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1, duration: 0.1 }])

      setFilterWork(
        item === 'All' ? works : works.filter(work => work.tags.includes(item)),
      )
    }, 500)
  }

  return (
    <>
      <h2 className="head-text">
        Personal <span>Works</span> showcase
      </h2>

      <div className="app__work-filter">
        {WORK_FILTERS.map(item => (
          <button
            type="button"
            key={item}
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${
              activeFilter === item ? 'item-active' : ''
            }`}>
            {item}
          </button>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio">
        {filterWork.map(
          ({
            status,
            imgUrl,
            name,
            projectLink,
            codeLink,
            title,
            description,
          }) => (
            <div
              className={`${!status && 'disabled'} app__work-item app__flex}`}
              key={`work_${rid()}`}>
              <div className="app__work-img app__flex">
                <img
                  className={`${!status && 'disabled'}`}
                  src={urlFor(imgUrl)}
                  alt={name}
                />

                <motion.div
                  whileHover={{ opacity: [0, 1] }}
                  transition={{
                    duration: 0.25,
                    ease: 'easeInOut',
                    staggerChildren: 0.5,
                  }}
                  className="app__work-hover app__flex">
                  {status && (
                    <a
                      href={projectLink}
                      target="_blank"
                      aria-label={`work link ${name}`}
                      rel="noreferrer"
                      onClick={e => !status && e.preventDefault()}>
                      <div className="app__flex">
                        <AiFillEye />
                      </div>
                    </a>
                  )}
                  <a
                    href={codeLink}
                    aria-label={`work github link ${name}`}
                    target="_blank"
                    rel="noreferrer">
                    <div className="app__flex">
                      <AiFillGithub />
                    </div>
                  </a>
                </motion.div>
              </div>

              <div className="app__work-content app__flex">
                <h4 className="bold-text">{title}</h4>
                <p className="p-text" style={{ marginTop: 10 }}>
                  {description}
                </p>

                <div className="app__work-tag app__flex">
                  <div className={`${!status && 'disabled'}`} />
                </div>
              </div>
            </div>
          ),
        )}
      </motion.div>
    </>
  )
}

export default AppWrap(MotionWrap(Works, 'app__works'), 'app__primarybg')
